import useFooterLinks from 'modules/header/components/footer-links'
import styled from 'styled-components'

const YEAR = new Date().getFullYear()

const Container = styled.div`
    background: rgba(0, 0, 0, 0.25);
    text-align: center;
`
const Content = styled.div`
    display: inline-block;
    font-size: 15px;
    line-height: 1;
    padding: 30px 0;
`

const Copyright = styled.div`
    display: inline-block;
    font-family: 'nexablack', sans-serif;
    margin-right: 30px;
`

const Links = styled.div`
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    display: inline-block;

    a {
        margin-left: 30px;
    }
`

const ZoomMakerWelcomeFooterLinks = () => {
    const footerLinks = useFooterLinks()

    return (
        <Container>
            <Content>
                <Copyright>{YEAR} GIPHY, Inc.</Copyright>
                <Links>
                    {footerLinks.map(({ url, label }) => (
                        <a key={label.toLowerCase().replace(/ /g, '-')} href={url} target="_blank" rel="noreferrer">
                            {label}
                        </a>
                    ))}
                </Links>
            </Content>
        </Container>
    )
}

export default ZoomMakerWelcomeFooterLinks
